import { useAsyncData } from "#imports";

export interface CategoryItem {
  id: string;
  label: string;
  slug: string;
  order: number;
  isVisible: boolean;
  parentId: string | null;
}

/**
 * Public, SSR-friendly source of truth for categories (REFACTOR_PLAN п.4).
 * Reads ТІЛЬКИ через GET /api/categories (кешований 5 хв на сервері).
 * Ключ "categories" навмисно спільний для всіх споживачів — Nuxt дедуплікує
 * запит на один рендер. Адмінський CRUD — окремо в composables/admin/useCategories.
 */
export function useCategoriesData() {
  const { data, pending, error, refresh } = useAsyncData<CategoryItem[]>(
    "categories",
    () => $fetch("/api/categories"),
    { default: () => [] },
  );
  return { cats: data, pending, error, refresh };
}
